import { useEffect, useRef } from "react";

import { withEventTargetValue } from "neetocommons/utils/general";
import useHotkeys from "neetohotkeys";
import { Check, Close } from "neetoicons";
import { Button, Input } from "neetoui";
import { isEmpty } from "ramda";

import { mergeRefs } from "./utils";

const Editor = ({
  placeholder,
  allowEmptySubmission,
  name,
  isLoading,
  handleRename,
  submitButtonProps,
  handleClose,
  cancelButtonProps,
  setName,
  inputProps,
  editMode,
}) => {
  const inputRef = useRef();

  const closeRef = useHotkeys("escape", event => handleClose({ event }), {
    mode: "scoped",
    enabled: editMode,
  });

  const submitRef = useHotkeys(
    ["command+return", "return"],
    event => {
      if (isEmpty(name) && !allowEmptySubmission) return;
      handleRename(event, name);
    },
    { mode: "scoped", enabled: editMode }
  );

  useEffect(() => {
    inputRef.current.select();
  }, []);

  return (
    <div className="relative flex min-w-0 max-w-full flex-grow">
      <span className="neeto-molecules-rename__input-width-maker">
        {name.replace(/\s/g, ".") || placeholder}
      </span>
      <Input
        {...{ placeholder }}
        autoFocus
        className="neeto-molecules-rename__input absolute"
        data-testid="form-rename-text-field"
        ref={mergeRefs(closeRef, submitRef, inputRef)}
        value={name}
        suffix={
          <div className="flex items-center justify-end">
            <Button
              className="neeto-ui-rounded-none"
              data-testid="form-rename-submit-button"
              disabled={(!allowEmptySubmission && isEmpty(name)) || isLoading}
              icon={Check}
              loading={isLoading}
              style="text"
              onClick={event => handleRename(event, name)}
              {...submitButtonProps}
            />
            <Button
              className="neeto-ui-rounded-none"
              data-testid="form-rename-close-button"
              disabled={isLoading}
              icon={Close}
              style="text"
              onClick={event => handleClose({ event })}
              {...cancelButtonProps}
            />
          </div>
        }
        onChange={withEventTargetValue(setName)}
        onClick={event => event.stopPropagation()}
        {...inputProps}
        label={null}
      />
    </div>
  );
};

export default Editor;
